exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-check.invoice[data-v-1c9859c4] {\n    margin-top: 0px;\n}\n", ""]);

// exports
